import React from 'react';
import { Modal } from 'semantic-ui-react';

interface ImageOnS3Props {
    imgKey: string;
    width: string;
    height: string;
    /** If true (default), clicking opens a larger preview. */
    enableLightbox?: boolean;
}

type ImageOnS3State = {
    lightboxOpen: boolean;
};

class ImageOnS3 extends React.Component<ImageOnS3Props, ImageOnS3State> {
    src: string = '';

    constructor(props: ImageOnS3Props) {
        super(props);
        const bucket = process.env.REACT_APP_S3_BUCKET;
        const region = process.env.REACT_APP_S3_REGION;
        this.src = `https://${bucket}.s3.${region}.amazonaws.com`;
        this.state = { lightboxOpen: false };
    }

    get fullUrl(): string {
        return `${this.src}/${this.props.imgKey}`;
    }

    openLightbox = () => {
        const { imgKey, enableLightbox = true } = this.props;
        if (imgKey && enableLightbox) {
            this.setState({ lightboxOpen: true });
        }
    };

    closeLightbox = () => this.setState({ lightboxOpen: false });

    render() {
        const { imgKey, width, height, enableLightbox = true } = this.props;
        const clickable = Boolean(imgKey && enableLightbox);

        return (
            <React.Fragment>
                {imgKey ? (
                    <>
                        <img
                            src={this.fullUrl}
                            width={width}
                            height={height}
                            alt=""
                            role={clickable ? 'button' : undefined}
                            tabIndex={clickable ? 0 : undefined}
                            onClick={this.openLightbox}
                            onKeyDown={
                                clickable
                                    ? (e) => {
                                          if (e.key === 'Enter' || e.key === ' ') {
                                              e.preventDefault();
                                              this.openLightbox();
                                          }
                                      }
                                    : undefined
                            }
                            style={{
                                backgroundColor: '#cecece',
                                cursor: clickable ? 'zoom-in' : undefined,
                                verticalAlign: 'middle',
                            }}
                        />
                        <Modal
                            open={this.state.lightboxOpen}
                            onClose={this.closeLightbox}
                            size="fullscreen"
                            style={{ marginTop: 0 }}
                        >
                            <Modal.Content
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    minHeight: '90vh',
                                    background: 'rgba(0,0,0,0.92)',
                                    padding: '1rem',
                                }}
                            >
                                <button
                                    type="button"
                                    onClick={this.closeLightbox}
                                    aria-label="Close image preview"
                                    style={{
                                        position: 'fixed',
                                        top: '1rem',
                                        right: '1rem',
                                        zIndex: 2000,
                                        width: '42px',
                                        height: '42px',
                                        border: 'none',
                                        borderRadius: '50%',
                                        background: 'rgba(0,0,0,0.7)',
                                        color: '#fff',
                                        fontSize: '26px',
                                        lineHeight: 1,
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        boxShadow: '0 0 0 1px rgba(255,255,255,0.35)',
                                    }}
                                >
                                    ×
                                </button>
                                <img
                                    src={this.fullUrl}
                                    alt=""
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: 'calc(100vh - 4rem)',
                                        width: 'auto',
                                        height: 'auto',
                                        objectFit: 'contain',
                                    }}
                                />
                            </Modal.Content>
                        </Modal>
                    </>
                ) : (
                    'хоосон'
                )}
            </React.Fragment>
        );
    }
}

export default ImageOnS3;
